import 'css-chunksrc/client/pages/projectPage/kanbanPage/toolbar/sort/styles.scss';export default {
  "sort": "_sort_4gszf_1",
  "rootClassName": "_rootClassName_4gszf_10",
  "input": "_input_4gszf_14",
  "openedInput": "_openedInput_4gszf_31",
  "iconOpen": "_iconOpen_4gszf_37",
  "icon": "_icon_4gszf_37",
  "listRoot": "_listRoot_4gszf_54",
  "list": "_list_4gszf_54",
  "title": "_title_4gszf_70",
  "item": "_item_4gszf_76",
  "selected": "_selected_4gszf_85"
};